import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { FadeInOutAnimation } from 'app/components/Common/FadeInOutAnimation'
import {
  Props as ServicesProps,
  Service,
} from 'app/components/IconsServices/Service'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { theme } from 'app/theme/index'
import React, { memo } from 'react'

export interface Props {
  comfortServices?: ServicesProps[]
  comfortTitle?: string
  plusServices?: ServicesProps[]
  plusTitle?: string
  variant?: Variant
}

export const ServicesStripe = memo(function ServicesStripe({
  comfortServices,
  comfortTitle,
  plusServices,
  plusTitle,
  variant = 'default',
}: Props) {
  return (
    <Container variant={variant}>
      {comfortTitle ? (
        <FadeInOutAnimation>
          <Title>{comfortTitle}</Title>
        </FadeInOutAnimation>
      ) : null}
      {comfortServices ? (
        <FadeInOutAnimation>
          <Services dial={2} row wrap variant={variant}>
            {comfortServices.map((item, index) => {
              return <Service key={index} {...item} />
            })}
          </Services>
        </FadeInOutAnimation>
      ) : null}
      {plusTitle ? (
        <FadeInOutAnimation>
          <Title>{plusTitle}</Title>
        </FadeInOutAnimation>
      ) : null}
      {plusServices ? (
        <FadeInOutAnimation>
          <Services dial={2} row wrap variant={variant}>
            {plusServices.map((item, index) => {
              return <Service key={index} {...item} />
            })}
          </Services>
        </FadeInOutAnimation>
      ) : null}
    </Container>
  )
})

const Container = styled.section<ContainerProps>`
  background: ${({ theme }) => theme.colors.variants.neutralLight3};
  margin-bottom: 7.5rem;
  text-align: center;

  ${({ variant }) => {
    switch (variant) {
      case 'simple':
        return css`
          background: ${theme.colors.variants.neutralLight4};
          margin: -3.75rem auto 2.25rem;
        `
    }
  }}

  @media (max-width: 767px) {
    margin-bottom: 5.25rem;
  }
`

const Title = styled.h2`
  display: flex;
  align-items: center;
  flex-direction: row;
  color: ${({ theme }) => theme.colors.variants.neutralDark1};
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 1.5rem;
  line-height: 2rem;
  &:before,
  &:after {
    content: '';
    flex: 1 1;
    background: ${({ theme }) => theme.colors.variants.neutralLight1};
    height: 2px;
  }
  &:before {
    margin-right: 1.5rem;
  }
  &:after {
    margin-left: 1.5rem;
  }
`

const Services = styled(FlexBox)<ContainerProps>`
  max-width: 53.125rem;
  margin: auto;
  padding-bottom: 5.25rem;
  > div {
    width: 20%;
    margin-top: 2.25rem;
    div {
      width: 3rem;
      height: 3rem;
      img {
        height: 1.25rem;
      }
    }
    label {
      margin-top: 0.5rem;
    }
  }

  ${({ variant }) => {
    switch (variant) {
      case 'simple':
        return css`
          > div {
            div {
              background: ${theme.colors.variants.neutralLight3};
            }
          }
        `
    }
  }}
`

interface ContainerProps {
  variant: Variant
}

export type Variant = 'default' | 'simple'
